import React, { useState } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import { FaRegCalendar } from "react-icons/fa6";
import { LuFilter } from "react-icons/lu";
import { FaAngleRight } from "react-icons/fa6";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { useTabletMediaQuery, useMobileMediaQuery } from '../utils';
import '../css/customButton.css';
import DotsLoading from '../components/DotsLoading'


const CustomButton = (props) => {
    const {
        text = '',
        onPress = () => { },
        enabled = true,
        loading = false,
        hasArrow = false,
        hasShadow = true,
        justText = false,
        color = 'transparent',
        fontSize= '13px',
        hoverColor = 'none',
        textColor = '#000',
        hoverTextColor = 'none',
        iconColor = '#000',
        borderColor = 'transparent',
        hoverBorderColor = 'none',
        hasSubLine = false,
        hasSubLineSmall = false,
        hasSubLineSmallColor = 'transparent',
        iconType = 'arrow',
        isSmall = false,
        hasShadowWithe = false,
    } = props;

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();
    const [isHovered, setIsHovered] =  useState(false);
    const [isFocused, setIsFocused] =  useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };

    const buttonClass = isTablet ? 
        ( hasShadow ? 
                ( hasShadowWithe ? "btnCustomButtonWitheShadow" : "btnCustomButton") 
            : 
                ( justText ? "btnNoShadowJustTextCustomButton" : "btnNoShadowCustomButton")
        )
    : 
        ( isMobile ? 
                ( hasShadow ? "btnCustomButton" : "btnNoShadowCustomButton" ) 
            : 
                ( hasShadow ? 
                        ( isSmall ? "btnSmallCustomButtonMobile" : "btnCustomButtonMobile") 
                    : 
                        ( isSmall ? 
                                ( justText ? "btnNoShadowJustTextCustomButton" : "btnNoShadowSmallCustomButtonMobile") 
                            : 
                                ( justText ? "btnNoShadowJustTextCustomButton" : "btnNoShadowCustomButtonMobile")
                        )
                ) 
        );

    const arrowIconClass = isTablet
        ? "arrowIconCustomButton"
        : "arrowIconCustomButtonMobile";

    const arrowRotateIconClass = isTablet
        ? "arrowRotateIconCustomButton"
        : "arrowRotateIconCustomButtonMobile";

    const arrowIconClassContacts = isTablet
    ? "arrowIconContactsCustomButton"
    : "arrowIconContactsCustomButtonMobile";

    const buttonSubLineClass = isTablet
        ? "btnSubLineMainContainerCustomButton"
        : "btnSubLineMainContainerCustomButtonMobile";

    const buttonStyle = {
        backgroundColor: isHovered ? hoverColor : color,
        color: isHovered ? hoverTextColor : textColor,
        borderColor:  isHovered ? hoverBorderColor : borderColor,
        fontSize: fontSize,
        transition: 'all 200ms ease-in-out',
    };

    const iconStyle = {
        color: iconColor,
    };

    return (
        <>
        <button
            className={ hasSubLine ? buttonSubLineClass : buttonClass}
            type='button'
            onClick={onPress}
            style={buttonStyle}
            disabled={!enabled || loading}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onFocus={handleFocus}
            onBlur={handleBlur}
        >
            { loading ? <DotsLoading /> : (
            <>
                {text}
                {hasArrow && iconType === 'arrow' && (
                    <FaArrowRightLong className={arrowIconClass} style={iconStyle} />
                )}

                {hasArrow && iconType === 'check' && (
                    <FaCheck className={arrowIconClass} style={iconStyle} />
                )}

                {hasArrow && iconType === 'calendar' && (
                    <FaRegCalendar className={arrowIconClass} style={iconStyle} />
                )}

                {hasArrow && iconType === 'filter' && (
                    <LuFilter  className={arrowIconClass} style={iconStyle} />
                )}

                {hasArrow && iconType === 'right' && (
                    <FaAngleRight className={arrowIconClass} style={iconStyle} />
                )}

                {hasArrow && iconType === 'email' && (
                    <MdOutlineMail className={arrowIconClassContacts} style={iconStyle} />
                )}

                {hasArrow && iconType === 'phone' && (
                    <MdOutlinePhoneInTalk className={arrowIconClassContacts} style={iconStyle} />
                )}

                {hasArrow && iconType === 'close' && (
                    <IoMdClose className={arrowIconClassContacts} style={iconStyle} />
                )}

                {hasArrow && iconType === 'arrowOutward' && (
                    <FaArrowRightLong className={arrowRotateIconClass} style={iconStyle} />
                )}
            </>
            )} 
        </button>
        { hasSubLineSmall && 
            <div className="hasSubLineSmallCustomButton" style={{ backgroundColor: hasSubLineSmallColor, width: isMobile ? (isHovered ? "100%" : "30%") : "100%", opacity: enabled ? 1 : 0.32 }}></div>
        }
        </>
    );
};

export default CustomButton;